export const RESUMEN_COMPRA_ROUTE = '/cotizador/pago';
export const PROCESANDO_PAGO_ROUTE = '/cotizador/procesando_pago';
export const SARLAFT_REQUIRED_ACTION_ROUTE = '/cotizador/sarlaft-required-action';
export const INACTIVITY_TIMEOUT_ROUTE = '/cotizador/inactividad-timeout';
export const INACTIVITY_TIMEOUT_RETURN_URL_KEY = 'inactivity_timeout_return_url';
